import { render } from "./ExpertView.vue?vue&type=template&id=158a2288"
import script from "./ExpertView.vue?vue&type=script&lang=js"
export * from "./ExpertView.vue?vue&type=script&lang=js"

import "./ExpertView.vue?vue&type=style&index=0&id=158a2288&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__